export const FileOnRecordDeprecatedFragment = gql`
  fragment FileOnRecordDeprecatedFragment on FileOnRecordToBeDeprecated {
    fileId
    fileName
    type
  }
`
